import * as React from "react";
import { tl } from "../../../../../../utils";

interface IProps {
  src: string;
  name: string;
  autoplay?: boolean;
}

function strip(html: string) {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText;
}

export const Audio = (props: IProps) => {
  const [downloadAudio, setDownloadAudio] = React.useState(null);

  let audio: any = null;

  React.useEffect(() => {
    setDownloadAudio(props.src);
    (window as any).audioplayerNew(audio);
    if (props.autoplay) {
      audio.play();
    }
  }, [props.src]);

  return (
    <audio
      ref={(node) => (audio = node)}
      data-filename={strip(props.name)}
      data-source={props.src}
      preload="metadata"
      controls
    >
      {/* TODO: добавить протектор */}
      {downloadAudio === props.src ? <source src={props.src} /> : null}
      {/* TODO: добавить type */}
      {tl(
        "Ваш браузер не поддерживает воспроизведение аудио в данном формате. Вы можете скачать аудиозапись."
      )}
    </audio>
  );
};
